module.exports = __webpack_public_path__ + "static/media/Celina_Cantidiano_Respiração_3_tempos.f57aa306.jpg";